import React, { useState } from 'react';
import ModalItem from '../../common/ModalItem/ModalItem';
import Container from '@material-ui/core/Container';
import { changeErrorPopupState, changeSuccessPopupState } from '../../../store/uiSlice';
import { connect } from 'react-redux';
import { useHistory, useLocation } from 'react-router';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import './dispute.scss';
import { Button } from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import YellowButton from '../../common/YellowButton';
import { useFormik } from 'formik';
import { postAppeal } from '../../../store/activitiesSlice';
import { completedRoutes } from '../../../common/constants';
import { get } from 'lodash';
import Divider from '@material-ui/core/Divider';

function Dispute(props) {
  const { t } = useTranslation();
  const location = useLocation();
  const solutionId = get(location, 'state.solutionId', null);
  const history = useHistory();
  const [showForm, setShow] = useState(false);

  const solution = props.activities.filter((i) => {
    return i.id === solutionId;
  })[0];

  const formik = useFormik({
    initialValues: {
      appealText: '',
    },
    onSubmit: (values) => {
      if (appealExpiringDate.isBefore(moment())) {
        props.changeErrorPopupState({ type: 'appealExpired', isOpen: true });
      } else {
        props.postAppeal(solutionId, values)
          .then(() => {
            props.changeSuccessPopupState({ type: 'sendAppeal', isOpen: true });
          })
          .catch((error) => {
            if (error.status === 401) {
              history.replace(completedRoutes.signUpModalItem,
                { currentUrl: completedRoutes.userActivityDispute, solutionId },
              );
            } else {
              console.error(error);
              props.changeErrorPopupState({ type: 'default', error, isOpen: true });
            }
          })
      }
    },
  });

  if (!solution) return null;

  const {
    state, task: { name: taskName }, rejectReason, rejectingTime, appealText,
    appealExpirationTime,
  } = solution;

  const solutionStatusesTranslation = t('solutionStatuses', { returnObjects: true });
  const solutionState = solutionStatusesTranslation[state];

  const rejectingDate = moment(rejectingTime.date);
  const appealExpiringDate = moment(appealExpirationTime.date).subtract(10, 'seconds');
  const now = moment();

  const isAppealExpired = appealExpiringDate.isBefore(now);
  const formattedDate = rejectingDate.isSame(now, 'day')
    ? rejectingDate.format('LT')
    : rejectingDate.format('D.MM.YYYY HH:mm');

  const handleShow = () => {
    if (appealExpiringDate.isBefore(moment())) {
      props.changeErrorPopupState({ type: 'appealExpired', isOpen: true });
    } else {
      setShow(true);
    }
  };

  return (
    <ModalItem>
      <>
        <Container className="dispute-container">
          <h3 className="title">{taskName}</h3>
          <div className="info-cnt">
            <span className="solution-state">{solutionState}</span>
            <span className="time">{formattedDate}</span>
          </div>
          <div>{rejectReason}</div>
          {appealText === null && !showForm && !isAppealExpired &&
          <Button variant="outlined" className="dispute-btn" onClick={handleShow}>
            <span className="text">{t('dispute.dispute')}</span>
          </Button>
          }
          {showForm && !isAppealExpired &&
          <form onSubmit={formik.handleSubmit}>
            <TextField
              label={t('dispute.messageText')}
              multiline
              name="appealText"
              className="message-input"
              value={formik.values.appealText}
              onChange={formik.handleChange}
            />
            <div className="submit">
              <YellowButton
                type="submit"
                title={t('common.send')}
                hidden={false}
                disabled={formik.values.appealText.length === 0}
              />
            </div>
          </form>
          }
          {appealText !== null &&
          <div>
            <h4>{t('dispute.yourDispute')}</h4>
            <p className="appeal-text">
              {appealText}
            </p>
          </div>
          }
          {
            appealText === null &&
            <div>
              <br />
              <Divider />
              <p className="appeal-time-info">
                {t('dispute.appealExplain')}
                <br />
                {isAppealExpired
                  ? <span className="time-over">{t('dispute.timeOver')}</span>
                  : <span className="green">
                    {t('dispute.restTime') + appealExpiringDate.from(now, true)}
                  </span>
                }
              </p>
            </div>
          }
        </Container>
      </>
    </ModalItem>
  );
}

const mapStateToProps = state => ({
  activities: state.activities.data,
});

const actionCreators = {
  changeErrorPopupState: changeErrorPopupState,
  changeSuccessPopupState: changeSuccessPopupState,
  postAppeal: postAppeal,
};

export default connect(mapStateToProps, actionCreators)(Dispute);
